import React from "react"
import styles from "./BlockMarginTextImageLeft.module.css"

const BlockMarginTextImageLeft = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockMarginTextImageLeft}>
      <div className={styles.blockMarginTextImageLeft__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
      <div className={styles.blockMarginTextImageLeft__text}>
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </section>
  )
}
export default BlockMarginTextImageLeft
